import { useRouter } from 'next/router';
import Dialog from 'epn-ui/umd/dist/components/Dialog';

// Helpers
import useI18n from '@i18n';
import { ISupportThemesAttributes } from '@api/types';
import { removeQueryParams } from '@utils/router';
import { ITicketSubmitParams } from './templates/interface';

// Components
import OtherForm from './templates/Other';
import ToolsForm from './templates/Tools';
import OrderForm from './templates/Order';

export interface ICreateMessageModalProps {
    isOpen: boolean;
    onClose: () => void;
    loading: boolean;
    onSubmit: (params: ITicketSubmitParams) => void;
    selectedTheme: ISupportThemesAttributes | null;
    question: string;
    subject: string;
}

const CREATE_MESSAGE_TEMPLATE = {
    '0': OtherForm,
    '1': OrderForm,
    '4': ToolsForm,
    '6': OtherForm,
};

const CreateMessageModal: React.FC<ICreateMessageModalProps> = ({
    isOpen,
    onClose,
    selectedTheme,
    question,
    subject,
    loading,
    onSubmit,
}) => {
    const { t } = useI18n('Support');
    const router = useRouter();
    const CreateForm = CREATE_MESSAGE_TEMPLATE[selectedTheme?.id] || CREATE_MESSAGE_TEMPLATE['0'];
    const preparedSubject = t(selectedTheme?.name) || subject || '';

    // Нужен для удаления параметров из урла.
    const onCloseInterceptor = () => {
        const fields = ['createSupportMessage', 'theme'];
        const queryFields = Object.keys(router.query);
        if (queryFields.some(field => fields.includes(field))) {
            removeQueryParams(fields, router);
        }
        onClose();
    };

    return (
        <Dialog
            open={isOpen}
            onCancel={onCloseInterceptor}
            title={t(selectedTheme?.name || 'Another problem')}
            size="lg"
        >
            <div id="support_create_message_modal">
                <CreateForm
                    onSubmit={onSubmit}
                    onClose={onCloseInterceptor}
                    subject={preparedSubject}
                    question={question}
                    loading={loading}
                />
            </div>
        </Dialog>
    );
};

export default CreateMessageModal;
